import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useGetClothTypesQuery } from '@api/baseApi';
import { selectSelectedType } from '@store/order/selectors';
import { AnimalTypeEnum } from '@api/types/AnimalTypeEnum';



interface PatternProps {
	animalType: AnimalTypeEnum,
}


const Pattern = (props: PatternProps) => {
	const { animalType } = props;
	const { t } = useTranslation('forms');

	const selectedType = useSelector(selectSelectedType);

	const { data, isLoading, isFetching, isError } = useGetClothTypesQuery({ animalType: animalType });

	const selectedCloth = data && data.length > 0 && selectedType ? data.find(x => x.id === selectedType) : null;

	
	if (isError || isFetching || isLoading || !selectedCloth) return (
		<div className='order-summary-element'>
			<h2>{t('patterns.sectionLabel')}</h2>
			<div className='summary-property'></div>
		</div>
	)

	
	return (
		<div className='order-summary-element'>
			<h2>{t('patterns.sectionLabel')}</h2>
			<div className='summary-property'>
				
				<div className='pattern-item disable-selection'>
					<img src={`data:image/jpeg;base64,${selectedCloth.base64}`} alt='pattern-item' draggable={false} />	
				</div>
			
			</div>
		</div>
	);
}

export default memo(Pattern);